module.exports = __webpack_public_path__ + "img/tss-3.2871b204.jpg";